// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__F6nJz","inputWrap":"Table_inputWrap__3xcTx","col":"Table_col__3AgPP","bmiTooltip":"Table_bmiTooltip__3p7eC"};